import { render, staticRenderFns } from "./faqBlock.vue?vue&type=template&id=62b3058a&"
import script from "./faqBlock.vue?vue&type=script&lang=js&"
export * from "./faqBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports